import styled from "styled-components"

export const StyleContainerMaster = styled.main`
    display: flex;
    flex-direction:column;
    justify-content: center;
    align-items: center;
    gap:5rem;
    
    header{
        width:100%;
    }
    @media(max-width: 451px){
        display: flex;
        flex-direction:column;
        justify-content: center;
        align-items: center;
        gap:3rem;
    }
`

export const StyledCorrectionMain = styled.section`
    display:flex;
    justify-content:center;
    align-items:center;
    flex-direction: column;
    width:100%;
    padding:1rem;
`

export const StyledCorrectionPage = styled.section`
    width:100%;
    max-width:1200px;
    border: solid 1px var(--color-gray-600);
    padding: 1rem;

`

export const StyledNavAddRealod = styled.nav`
    width:100%;
    display:flex;
    flex-direction:row-reverse;
    gap: 2rem;
    
`
export const StyleContainerReload = styled.div`
    button{
        cursor: pointer;
    }
    i{
        cursor: pointer;
    }
`
export const StyleContainerListTitle = styled.section`
    display:flex;
    align-items:center;
    justify-content:space-between;
    padding-bottom: 1rem;
    border-bottom: 1px solid #ccc;
    
       span{

           width:100%
       }
`